module.exports = __webpack_public_path__ + "static/media/latam-regional.66148518.png";